import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-trophy-line text-lg text-background-50"></i>
                </div>
                <span className="text-lg font-heading font-bold">每日大赛Yandex</span>
              </div>
              <p className="text-sm text-background-50/60 leading-relaxed">
                全球领先的在线竞技平台，每日赛事精彩不断，丰厚奖励等你来拿。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4">赛事分类</h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4">快速链接</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link
                    to="/"
                    className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    首页
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    关于我们
                  </Link>
                </li>
                <li>
                  <Link
                    to="/category/competition-rules"
                    className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    比赛规则
                  </Link>
                </li>
                <li>
                  <Link
                    to="/category/registration-guide"
                    className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    报名指南
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4">联系方式</h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-sm text-background-50/60">
                  <i className="ri-mail-line text-base"></i>
                  <span>support@yandex-contest.cn</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-background-50/60">
                  <i className="ri-phone-line text-base"></i>
                  <span>400-888-9999</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-background-50/60">
                  <i className="ri-wechat-line text-base"></i>
                  <span>yandex_contest_official</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/40">
              &copy; 2025 每日大赛Yandex官网 版权所有 | 京ICP备2025000001号
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors cursor-pointer">用户协议</a>
              <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors cursor-pointer" rel="nofollow">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}